import moment from "moment";
import { useEffect, useState } from "react";

const CalendarDays = ({
  days,
  datePicker,
  setDatePicker,
  minDate,
  maxDate,
}) => {
  const firstDayOfMonth = new Date(days.getFullYear(), days.getMonth(), 1);
  const weekdayOfFirstDay = firstDayOfMonth.getDay();
  const [currentDays, setCurrentDays] = useState([]);

  const setDate = (date) => {
    if (!datePicker?.start || !datePicker?.end) {
      if (
        moment(date).isSameOrBefore(moment(datePicker?.start)) ||
        !datePicker?.start
      ) {
        setDatePicker({
          ...datePicker,
          start: date,
        });
      } else if (!datePicker?.end) {
        setDatePicker({
          ...datePicker,
          end: date,
        });
      }
    } else {
      setDatePicker({
        start: date,
        end: null,
      });
    }
  };

  useEffect(() => {
    let currentDay = [];
    for (let day = 0; day < 42; day++) {
      let selected = false;
      if (day === 0 && weekdayOfFirstDay === 0) {
        firstDayOfMonth.setDate(firstDayOfMonth.getDate() - 7);
      } else if (day === 0) {
        firstDayOfMonth.setDate(
          firstDayOfMonth.getDate() + (day - weekdayOfFirstDay)
        );
      } else {
        firstDayOfMonth.setDate(firstDayOfMonth.getDate() + 1);
      }

      if (
        moment(firstDayOfMonth).isBetween(
          moment(datePicker?.start),
          moment(datePicker?.end ?? datePicker?.start),
          "days",
          "[]"
        )
      ) {
        selected = true;
      }

      let calendarDay = {
        currentMonth: firstDayOfMonth.getMonth() === days.getMonth(),
        date: new Date(firstDayOfMonth),
        month: firstDayOfMonth.getMonth(),
        number: firstDayOfMonth.getDate(),
        selected: firstDayOfMonth.toDateString() === new Date().toDateString(),
        minDate: minDate
          ? moment(firstDayOfMonth).isBefore(moment(minDate))
          : false,
        maxDate: maxDate
          ? moment(firstDayOfMonth).isAfter(moment(maxDate))
          : false,
        range: selected,
        year: firstDayOfMonth.getFullYear(),
      };

      currentDay.push(calendarDay);
    }
    setCurrentDays(currentDay);
  }, [datePicker, days]);

  return (
    <div className="w-full grow flex box-border justify-between flex-wrap">
      {currentDays.map((day, index) => {
        return (
          <div
            key={index}
            className={
              "w-[35px] h-[35px] relative text-center" +
              (day.currentMonth ? " text-black" : " invisible") +
              (day.selected && !day.range
                ? " border rounded-xl border-black bg-gray-200 text-black"
                : "") +
              ((day.minDate || day.maxDate) ? " text-gray-200": " cursor-pointer") +
              (day.range && day.selected ? " bg-black text-white" : "") +
              (day.range ? " bg-black text-white" : "")
            }
            onClick={() => {
              if (!day.minDate && !day.maxDate) {
                setDate(day?.date);
              }
            }}
          >
            <p className="absolute right-0 left-0 py-2 m-auto w-fit">
              {day.number}
            </p>
          </div>
        );
      })}
    </div>
  );
};

export default CalendarDays;
